import { getAnalytics, setUserProperties, logEvent } from "firebase/analytics";
import SparkMD5 from "spark-md5";
import { setCookie, parseCookie } from "./internal/cookie.js";
const TRACKING_TAG_VERSION = 5.1;
const VOS_COOKIE_KEY = "vos";
const INTR_COOKIE_KEY = "intr";
const HASHED_USER_ID_COOKIE_KEY = "ss_huid";
const HASHED_ACCOUNT_ID_COOKIE_KEY = "ss_auid";
const OPTIMIZELY_END_USER_ID_COOKIE_KEY = "optimizelyEndUserId";
const OPTIMIZELY_ACTIVE_BUCKETS_COOKIE_KEY = "optimizelyActiveBuckets";
const KARTE_VIS_COOKIE_KEY = "krt.vis";
const TD_CLIENT_COOKIE_KEY = "_td";
const MAX_ALLOWED_STRING_LENGTH = 100;
class FirebaseTracker {
  constructor(app, options) {
    this.analytics = getAnalytics(app);
    this.options = options;
  }
  track(userId, eventName, eventParams) {
    var _a;
    const firebaseParams = {
      tag_version: TRACKING_TAG_VERSION,
      fragment: location.hash
    };
    const userProps = {};
    try {
      if (userId) {
        userProps.user_id = userId;
        firebaseParams.user_id = userId;
        if ((_a = this.options) == null ? void 0 : _a.storeHashedUserIdCookieKey) {
          setCookie(
            this.options.storeHashedUserIdCookieKey,
            new SparkMD5().append(userId).end(),
            365
          );
        }
      }
      firebaseParams.intr = parseCookie(INTR_COOKIE_KEY);
      firebaseParams.vos = parseCookie(VOS_COOKIE_KEY);
      const hashedUserIdInCookie = parseCookie(HASHED_USER_ID_COOKIE_KEY);
      if (hashedUserIdInCookie) {
        userProps.hashed_user_id = hashedUserIdInCookie;
      }
      const hashedAccountIdInCookie = parseCookie(HASHED_ACCOUNT_ID_COOKIE_KEY);
      if (hashedAccountIdInCookie) {
        userProps.hashed_account_id = hashedAccountIdInCookie;
      }
      const optimizelyEndUserId = parseCookie(
        OPTIMIZELY_END_USER_ID_COOKIE_KEY
      );
      if (optimizelyEndUserId) {
        userProps.optimizely_end_user_id = optimizelyEndUserId;
      }
      const optimizelyActiveBuckets = parseCookie(
        OPTIMIZELY_ACTIVE_BUCKETS_COOKIE_KEY
      );
      if (optimizelyActiveBuckets) {
        if (JSON.stringify(optimizelyActiveBuckets).length > MAX_ALLOWED_STRING_LENGTH) {
          firebaseParams.wrapper_error = "beyond the max param limitation";
        } else {
          firebaseParams.optimizely_active_buckets = optimizelyActiveBuckets;
        }
      }
      const karteVis = parseCookie(KARTE_VIS_COOKIE_KEY);
      if (karteVis) {
        firebaseParams.karte_vis = karteVis;
      }
      const tdClientId = parseCookie(TD_CLIENT_COOKIE_KEY);
      if (tdClientId) {
        firebaseParams.td_client_id = tdClientId;
      }
      const uaPrefix = window.navigator.userAgent.split("/")[0];
      if (uaPrefix && uaPrefix.length <= 100) {
        firebaseParams.ua_prefix = uaPrefix;
      }
    } catch (e) {
      firebaseParams.wrapper_error = `raised exception: ${e instanceof Error ? e.message : String(e)}`;
    }
    setUserProperties(this.analytics, userProps);
    logEvent(this.analytics, eventName, { ...firebaseParams, ...eventParams });
  }
  trackEvent(userId, eventName, eventParams) {
    this.track(userId, eventName, eventParams);
  }
  trackPageView(userId) {
    this.track(userId, "pageviews");
  }
}
export {
  FirebaseTracker
};
